import styled from 'styled-components';
const ManeWrapper = styled.div`
  display: flex;
  height: 100vh;
`;
const RightWrapper = styled.div`
  width: 100%;
  margin-left: 225px;
  overflow-x: hidden;
`;
export { ManeWrapper, RightWrapper };
